import { registerBlockType } from '@wordpress/blocks';
import './style.css';
import Edit from './edit';

require('uploadcare-widget');
require('../../assets/js/index');

registerBlockType('wcu/woocommerce-file-uploader', {
	apiVersion: 2,
	title: 'WooCommerce File Uploader',
	category: 'media',
	icon: 'format-gallery',
	description: 'File uploader block for WooCommerce.',
	keywords: ['upload', 'file', 'woocommerce'],
	attributes: {},
	edit: Edit,
	save: () => null,
});
